import { render, staticRenderFns } from "./PrivateFileUploader.vue?vue&type=template&id=6edf0a20&"
import script from "./PrivateFileUploader.vue?vue&type=script&lang=js&"
export * from "./PrivateFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports